<script setup lang="ts">
import { TagsInputItem, type TagsInputItemProps, useForwardProps } from 'radix-vue'
import { computed, type HTMLAttributes } from 'vue'

import { Badge, type BadgeVariants } from '@/components/ui'

const props = defineProps<
  TagsInputItemProps & { variant?: BadgeVariants['variant']; class?: HTMLAttributes['class'] }
>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <TagsInputItem v-bind="forwardedProps" :as="Badge" :variant="variant" :class="props.class">
    <slot />
  </TagsInputItem>
</template>
